export interface MenuItemBase {
  id: number | string;
  name?: string;
  label?: string;
  parentId?: number | string | null;
  sort?: number;
  icon?: string | React.ReactNode;
  path?: string;
  hasPermission?: boolean;
  children?: MenuItemBase[];
}

// Utility: find active root item by longest prefix match (for horizontal menu)
export const findActiveRootItemByPath = <T extends MenuItemBase>(resources: T[], pathname: string): T | null => {
  let bestMatch: T | null = null;
  let bestLength = 0;
  for (const item of resources) {
    if (item.path && pathname.startsWith(item.path) && item.path.length > bestLength) {
      bestMatch = item;
      bestLength = item.path.length;
    }
  }
  return bestMatch;
};
